module.exports = __webpack_public_path__ + "img/xindr.a575af97.svg";